import { css } from '@/styled-system/css';

export const loadingMaskRootStyles = css.raw({
  display: 'inline-flex',
  position: 'relative',
});
